<template>

  <div>
<!--    <iframe :src="ReportUrl1" id="mobsf" frameborder="0" style="position:absolute;"></iframe>-->
    <iframe :src="ReportUrl1"
            width = "100%"
            height = "800px"
            frameborder = "0"
            scrolling=no
    >

    </iframe>
  </div>

</template>

<script>
  import Report from '@/api/common/hrcloudCommon';
    export default {
        name: "Report",
      data () {
        return {
          ReportUrl1:''
        }
      },
      mounted(){
          this.showReport();
        /**
         * iframe-宽高自适应显示
         */
        function changeMobsfIframe(){
          const mobsf = document.getElementById('mobsf');
          const deviceWidth = document.body.clientWidth;
          const deviceHeight = document.body.clientHeight;
          mobsf.style.width = (Number(deviceWidth)-220) + 'px'; //数字是页面布局宽度差值
          mobsf.style.height = (Number(deviceHeight)-80) + 'px'; //数字是页面布局高度差
        }

        changeMobsfIframe()
        window.onresize = function(){
          changeMobsfIframe()
        }

      },
      methods:{
          showReport(){

            let ReportId =  sessionStorage.getItem("cusId")
            console.log("ReportId",ReportId)
            let ReportUrl = Report.Report_Cli_URL+"reportTools/newreportList/"+ReportId;
            console.log("ReportUrl",ReportUrl)
             this.ReportUrl1 = ReportUrl
            if (ReportId != ""){
              this.$message.success("查询成功")
            }else {
              this.$message.warning("暂无数据")
            }


          }
      }

    }
</script>

<style scoped>

</style>
